import { useState } from 'react'
import {
	Row,
	Col,
	Card,
	Form,
	InputGroup,
	Button,
	Modal
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import AuthenticationService from '../../services/authenticationService'

const ForgotPassword: React.FC = () => {
	const [email, setEmail] = useState('')
	const [show, setShow] = useState(false)
	const { t } = useTranslation()
	const navigate = useNavigate()

	const handleSubmit = (event:any) => {
		event.preventDefault()
		event.stopPropagation()
		try {
			AuthenticationService.forgotPassword(email)
				.then(() => {
					setShow(true)
				})
				.catch(error => console.error(error))
		} catch (error) {
			console.error(error)
		}
	}
	return (
		<>
			<Modal
				show={show}
				onHide={() => setShow(false)}
			>
				<Modal.Header closeButton />
				<Modal.Body>
					<p className='text-center'>
						{t('forgot_password.check_email')}
					</p>
				</Modal.Body>
			</Modal>
			<Row className='justify-content-center'>
				<Col md={6}>
					<Card className='mt-5'>
						<Card.Body style={{ padding: '50px', textAlign: 'center' }}>
							<br />
							<h2>{t('login.forgot_password')}</h2>
							<br />
							<p style={{ color: '#6c757d' }}>
								{t('forgot_password.enter_email_to_reset_password')}
							</p>
							<br />
							<Form onSubmit={handleSubmit}>
								<InputGroup>
									<InputGroup.Text style={{ borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px', backgroundColor: 'white', borderRight: '0px', borderColor: '#EBEBEB' }}>
										<FontAwesomeIcon icon={faEnvelope} />
									</InputGroup.Text>
									<Form.Control
										size='lg'
										placeholder={t('login.email_address')}
										style={{ borderTopRightRadius: '10px', borderBottomRightRadius: '10px', borderLeft: '0px', borderColor: '#EBEBEB' }}
										type='email'
										value={email}
										onChange={event => setEmail(event.target.value)}
										required
										pattern='[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$'
										title='Please enter a valid email address.'
									/>
								</InputGroup>

								<Row>
									<Col style={{ textAlign: 'right', marginTop: '5px' }}>
										<Button onClick={()=>navigate('/login')} variant='link' className='text-decoration-none'>{t('login.login')}</Button>
									</Col>
								</Row>

								<br />
								<Button variant='primary' className='text-white' type='submit' size='lg' style={{ width: '100%', borderRadius: '10px' }}>
									{t('forgot_password.reset_password')}
								</Button>
								<br /><br />
							</Form>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</>
	)
}


export default ForgotPassword
